import React, { ReactNode, ReactElement } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useLocalStorage } from "../auth/useLocalStorage";

interface IUser {
  token?: string;
  userId?: string;
  userName?: string;
  user?: {
    perfil?: string;
    nombre?: string;
  };
  login?: any;
  logout?: any;
}

interface IProps {
  children: ReactNode;
  allowedProfiles: string[];
  redirectTo?: string;
}

const baseUser: IUser = {};

export default function ProfileRedirect({
  children,
  allowedProfiles,
  redirectTo
}: IProps): ReactElement | null {
  const [user] = useLocalStorage("user", baseUser);
  const location = useLocation();
  
  // Si no hay usuario logueado, redirigir al login
  if (!user?.token) {
    return <Navigate to="/login" replace />;
  }

  const userProfile = user?.user?.perfil;
  
  // Si el perfil del usuario está permitido en esta ruta, mostrar el contenido
  if (allowedProfiles.includes(userProfile)) {
    return <>{children}</>;
  }

  // Si hay una redirección específica definida, usarla
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  // Redirección automática basada en el perfil del usuario
  switch (userProfile) {
    case 'Cocina':
      // Si está intentando acceder a piso de venta, redirigir a cocina
      if (location.pathname === '/sales-floor') {
        return <Navigate to="/" replace />;
      }
      break;
    case 'PisoVenta':
      // Si está intentando acceder a cocina, redirigir a piso de venta
      if (location.pathname === '/') {
        return <Navigate to="/sales-floor" replace />;
      }
      break;
    default:
      // Para otros perfiles (como Administrador), permitir acceso a cualquier pantalla
      return <>{children}</>;
  }

  // Si llegamos aquí, mostrar el contenido (para casos edge)
  return <>{children}</>;
}
